import { register, init } from 'svelte-i18n';

register('en', () => import('../languages/en.json'));
register('sv', () => import('../languages/sv.json'));
register('da', () => import('../languages/da.json'));
register('is', () => import('../languages/is.json'));

let defaultLocale = 'en';

// Setting ititialLocale to defaultLocale since all setting and checking for locales will be handled somewhere else.

init({
    fallbackLocale: defaultLocale,
    initialLocale: defaultLocale,
});